export default __webpack_public_path__ + "static/media/img_tutor_howitworks_03@small.684b6660.png";